import { writer } from "@/backend/write/BackendWriter";
import { captureMessage } from "@/error/sentry";
import type { Shape } from "@/model/shape";
import { useBoardStore } from "@/store/board";
import { useBoardsStore } from "@/store/boards";
import { useDrawStore } from "@/store/draw";

import { action, ctxAction, defineActions, untrackedAction } from "./actions";

export const drawActions = defineActions("draw", {
  addShape: action(async (shape: Shape) => {
    const boardId = useBoardStore().currentBoard().id;
    shape.id = await writer.addShape(boardId, shape);
    return useBoardsStore().addShape(boardId, shape);
  }),
  editShape: untrackedAction(
    (ctx, shape: Shape) => {
      const boardId = useBoardStore().currentBoard().id;
      if (!shape.id) {
        // new shapes are persisted by addShape, so an unsaved shape must not reach here
        captureMessage("Cannot edit shape without shape id", { info: { boardId, shape } });
      } else if (!boardId || boardId === "0") {
        captureMessage("Cannot edit shape without board id", { info: { boardId, shape } });
      } else {
        useBoardsStore().editShape(boardId, shape);
        void writer.editShape(boardId, shape);
      }
      ctx.track(null);
    },
    { name: /*$t*/ "general.label", label: /*$t*/ "label.actionMenu.label", icon: "general/text" },
  ),
  removeShape: ctxAction(
    (ctx) => {
      const shapeId = useDrawStore().selected?.shape.id;
      if (!shapeId) {
        return ctx.track(null);
      }
      const boardId = useBoardStore().currentBoard().id;
      useBoardsStore().removeShape(boardId, shapeId);
      void writer.removeShape(boardId, shapeId);
      useDrawStore().unselect();
    },
    {
      name: /*$t*/ "general.delete",
      label: /*$t*/ "label.actionMenu.delete",
      icon: "general/delete",
    },
  ),
});
